import React, { useState, useEffect } from "react";
import HeaderSection from "../../../common/headerSection";
import PageHeader from "../../../common/pageHeader";
import { Link } from "react-router-dom";
import CustomTable from "../../../../widgets/table";
import Pagination from "../../../../widgets/pagination";
import { TfiClose } from "react-icons/tfi";
import { Modal } from "react-bootstrap";
import { dashboardServices } from "../../../../service/dashboard";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import translationData from '../../../../locales/dashboardTranslation.json'
import { userService } from "../../../../service/plateServices";
import DownloadPdf from "../../../../widgets/downloadPdf";
import { DEFAULT_PAGE_SIZE } from "../../../../constants/constants";
import { scheduleService } from "../../../../service/scheduleService";
import { areaService } from "../../../../service/areaServices";
import { helperFunctions as _h, helperFunctions } from "../../../../utils/helper";

const InnerPageDescrepency = () => {
    const { descrepencyId } = useParams();
    const { t } = useTranslation();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [scheduleDetails, setScheduleDetails] = useState([]);
    const displayName = getDisplayName(Number(descrepencyId));
    const [authToken, setAuthToken] = useState("");
    const [authUserID, setAuthUserID] = useState("");
    const [useEffectRequired, setUseEffectRequired] = useState(false)
    const [sort, setSort] = useState("id");
    const [order, setOrder] = useState("desc");

    // Filter states
    const [keyWord, setkeyWord] = useState("");
    const [activityTypeId, setActivityTypeId] = useState("");
    const [areaId, setAreaId] = useState("");
    const [proScheduleId, setProScheduleId] = useState("");
    const [location, setLocation] = useState("");
    const [productNameId, setProductNameId] = useState("");

    // Filter data lists
    const [activityTypeList, setActivityTypeList] = useState<Array<any>>([]);
    const [areaList, setAreaList] = useState<Array<any>>([]);
    const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
    const [locationList, setLocationList] = useState<Array<any>>([]);
    const [productList, setProductList] = useState<Array<any>>([]);
    const sortRemoveList=["status"]

    function getDisplayName(id: any) {
        const DiscrepancyHead = translationData.DiscrepancyHead;
        const descrepency = DiscrepancyHead.find(item => item.id === id);
        return descrepency ? descrepency.displayName : "";
    }

    //column header for discrepency view
    const columns: any = [
        {
            Header: "Sl.No",
            accessor: "slno",
        },
        {
            Header: "scheduleOperator.tableColumns.production_schedule",
            accessor: "production_schedule",
        },
        {
            Header: "scheduleOperator.tableColumns.product_name",
            accessor: "product_name",
        },
        
        {
            Header: "dashboard.pendingExceptionColumns.plateSerialNumber",
            accessor: "serial_number",
        },
        {
            Header: "dashboard.pendingExceptionColumns.batchNumber",
            accessor: "batch_number",
        },
        {
            Header: "dashboard.pendingExceptionColumns.exceptionReasons",
            accessor: "remarks",
        },
        {
            Header: "dashboard.pendingExceptionColumns.exceptionAddedBy",
            accessor: "exception_requested_user_firstname",
        },
        {
            Header: "dashboard.pendingExceptionColumns.exceptionAddedDate",
            accessor: "exception_requested_datetime",
        },
        {
            Header: "dashboard.pendingExceptionColumns.exceptionAddedArea",
            accessor: "exceptionAddedArea_name",
        },
        {
            Header: "dashboard.pendingExceptionColumns.locationName",
            accessor: "location_name",
        },
        {
            Header: "dashboard.pendingExceptionColumns.status",
            accessor: "status",
        },
    ]

    //column header for no test view
    const columnsNoTest: any = [
        {
            Header: "Sl.No",
            accessor: "slno",
        },
        {
            Header: "scheduleOperator.tableColumns.production_schedule",
            accessor: "production_schedule",
        },
        {
            Header: "scheduleOperator.tableColumns.product_name",
            accessor: "product_name",
        },
        
        {
            Header: "dashboard.pendingExceptionColumns.plateSerialNumber",
            accessor: "serial_number",
        },
        {
            Header: "scheduleFrequency.tableColumns.activity_type_name",
            accessor: "activity",
        },
        {
            Header: "scheduleProduction.tableColumns.area_name",
            accessor: "area",
        },
        {
            Header: "generatePlateQr.tableColumns.location",
            accessor: "location",
        },
        {
            Header: "Exception.remarks",
            accessor: "remarks",
        },
        {
            Header: "Exception.reason",
            accessor: "reasons",
        },
        {
            Header: "No Test Added By",
            accessor: "noTestAddedBy",
        },
        {
            Header: "No Test Added Date",
            accessor: "noTestAddedDate",
        },
        // {
        //     Header: "dashboard.pendingExceptionColumns.status",
        //     accessor: "status",
        // },
    ]

    //handle pagination 
    const handleSchedulePageChange = (newPage: any, newPageSize?: number) => {
        setPage(newPage);
        if (newPageSize) {
            setPageSize(newPageSize);
        }
        setUseEffectRequired(true)
    };

    //api call for inner page table listing 
    const fetchData = async (x_auth_token: string, x_user_id: string) => {
        try {
            let response;
            switch (descrepencyId) {
                case "1":
                    response = await dashboardServices.getDescrepencyDetails(
                        page, 
                        pageSize, 
                        16, 
                        x_auth_token, 
                        x_user_id, 
                        sort, 
                        order,
                        keyWord,
                        proScheduleId,
                        productNameId,
                        
                        
                    );
                    break;
                case "2":
                    response = await dashboardServices.getDescrepencyDetails(
                        page, 
                        pageSize, 
                        17, 
                        x_auth_token, 
                        x_user_id, 
                        sort, 
                        order,
                        keyWord,
                        proScheduleId,
                        productNameId,
                       
                        
                    );
                    break;
                case "3":
                    response = await dashboardServices.getNoTestDetails(
                        page, 
                        pageSize, 
                        x_auth_token, 
                        x_user_id, 
                        sort, 
                        order,
                        proScheduleId,
                        productNameId,
                        activityTypeId,
                        areaId,
                        location
                    );
                    break;
                default:
                    break;
            }

            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        setTotalPages(response.totalPages);
                        setTotalElements(response.totalElements);
                        let rowData = response.data.map((element: any, index: any) => {
                            const createdFirstName = element.exception_requested_user_firstname || '-';
                            const createdLastName = element.exception_requested_user_lastname || '-';
                            const fullName = createdFirstName + ' ' + createdLastName;

                            const statusNumber = parseInt(element.status, 10);
                            const plateStatus = userService.getPlateStatus(statusNumber);
                            return {
                                slno: index + 1,
                                serial_number: element.serial_number,
                                batch_number: element.batch_number,
                                remarks: element.remarks,
                                reasons: element.reason,
                                exception_requested_user_firstname: fullName,
                                exception_requested_datetime: helperFunctions.formatDate(element.exception_requested_datetime,true),
                                location: element.location_name,
                                exceptionAddedArea_name: element.area_name || '-',
                                location_name: element.location_name || '-',
                                production_schedule: element.production_schedule_name || '-',
                                product_name: element.product_name || '-',
                                operator_name: element.operator_name,
                                area: element.area_name,
                                activity: element.master_activity_name,
                                noTestAddedDate: helperFunctions.formatDate(element.created_at,true),
                                noTestAddedBy: element.operator_name,
                                status: plateStatus,
                            };
                        });
                        setScheduleDetails(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setScheduleDetails([]);
                setTotalPages(0);
                setTotalElements(0);
            }
        } catch (error) {
            console.error('API call error', error);
        }
    };

    // Get Activity Type List
    const getActivityTypeList = async () => {
        try {
            const response = await scheduleService.getActivityTypeList();
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    slno: index + 1,
                                    id: element.id,
                                    name: element.name,
                                };
                            }
                        );
                        setActivityTypeList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setActivityTypeList([]);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };

    // Get Area List
    const getAreaList = async (areaType: any, gradeId: any) => {
        try {
            const response = await areaService.getAreaList(0, 0, sort, order, "", areaType, "", gradeId);
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map((element: any, index: number) => {
                            const statusNumber = parseInt(element.type, 10);
                            const area_type = areaService.getLocationStatus(statusNumber);

                            return {
                                slno: index + 1,
                                id: element.id,
                                area_code: element.area_code,
                                name: element.name,
                                area_type: element.location_type_name,
                                status: element.status,
                                qr_image_path: element.qr_image_path,
                            };
                        });
                        setAreaList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setAreaList([]);
            }
        } catch (error) {
            console.error('user response', error);
        }
    };

    // Get Production Schedules
    const getProductionSchedules = async (areaId: string) => {
        try {
            const response = await scheduleService.getProductionSchedules(areaId);
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    slno: index + 1,
                                    id: element.id,
                                    production_schedule_name: element?.production_schedule_name,
                                };
                            }
                        );
                        setProdScheduleList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setProdScheduleList([]);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };

    // Get Location by Activity and Area
    const getLocationByActivity = async (activityId: any, areaId: any) => {
        try {
            const response = await areaService.getLocationByActivity(activityId, '', '', areaId);
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    slno: index + 1,
                                    id: element.id,
                                    name: element.name,
                                };
                            }
                        );
                        setLocationList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setLocationList([]);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };

    // Get Product List
    const getProductList = async () => {
        try {
            const response = await scheduleService.getProductList();
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    id: element.id,
                                    name: element.name,
                                };
                            }
                        );
                        setProductList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setProductList([]);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };

    // Handle filter changes
    const handleFilter = (key: string, value: any) => {
        if (key === "search") {
            setkeyWord(value);
        } else if (key === "activityType") {
            setActivityTypeId(value);
            getLocationByActivity(value, areaId);
        } else if (key === "area") {
            setAreaId(value);
            getLocationByActivity(activityTypeId, value);
            getProductionSchedules(value);
        } else if (key === "productionSchedule") {
            setProScheduleId(value);
        } else if (key === "location") {
            setLocation(value);
        } else if (key === "productName") {
            setProductNameId(value);
        }
        setUseEffectRequired(true);
    };

    // function to sort table
    const handleSort = (key: string, value: boolean) => {
        setSort(key)
        if (value) {
            setOrder("asc")
        } else {
            setOrder("desc")
        }
        setUseEffectRequired(true)
    }

    useEffect(() => {
        var storedData = localStorage.getItem('userDetails');
        if (storedData) {
            var storedObject = JSON.parse(storedData);
            setAuthToken(storedObject[0].x_auth_token)
            setAuthUserID(storedObject[0].x_userid)

            fetchData(storedObject[0]?.x_auth_token, storedObject[0]?.x_userid);
            setUseEffectRequired(false)
        }
    }, [descrepencyId, useEffectRequired]);

    useEffect(() => {
        // Initialize filter data
        getActivityTypeList();
        getAreaList("8,12,9,6,17", "");
        getProductList();
        getProductionSchedules("");
    }, []);

    return (
        <div>
            <HeaderSection />
            <PageHeader pageHeader={t('dashboard.title')} />
            <div id='dashWrap'>
                <nav aria-label="breadcrumb" className="breadcrumb-container row">
                    <div className='col-10 d-flex'>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item dashboard-hover">
                                <Link to="/*">{t('dashboard.title')}</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {displayName}
                            </li>
                        </ol>
                    </div>
                    <div className='col-2 d-flex'>
                        <DownloadPdf divId="dashWrap" reportHead="Descrepency Report" />
                    </div>
                </nav>

                <div className='col-md-12 mx-3 pe-5' style={{ "height": "45vh" }}>
                    <CustomTable
                        tableHead={displayName}
                        data={scheduleDetails}
                        columns={ descrepencyId === "3" ? columnsNoTest : columns}
                        isEditable={false}
                        isActionVisible={false}
                        isViewVisible={false}
                        totalElements={totalElements}
                        isSeachable={false}
                        isToggleStatus={false}
                        onUseEffectRequired={() => setUseEffectRequired(true)}
                        onSortClick={handleSort}
                        // Filter related props
                        onFilterClick={handleFilter}
                        showFullFilters={true}
                        ActivityType={activityTypeList}
                        areaDropList={areaList}
                        prodScheduleList={prodScheduleList}
                        locationList={locationList}
                        productList={productList}
                        removeSortList={sortRemoveList}
                    />
                </div>
                <div>
                    <Pagination
                        page={page}
                        totalPages={totalPages}
                        handlePageChange={handleSchedulePageChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default InnerPageDescrepency;